export default "__VITE_ASSET__FH7rNNvy__"